import { api } from '@api'
import { FetchParams, PaginatedResponse } from './types'
import { usePaginate } from './usePaginate'

export type UserGroup = {
  id: string
  name: string | null
  participants: {
    id: string
    avatarUrl: string | undefined
  }[]
  createdAt: string
  updatedAt: string
}

const fetchUserGroups = async ({ pageParam = '0', search }: FetchParams): Promise<PaginatedResponse<UserGroup>> => {
  let url = `/conversations?page=${pageParam}&type=GROUP`
  if (search) url += `&search=${encodeURIComponent(search)}`
  const { data } = await api.get<PaginatedResponse<UserGroup>>(url)
  return data
}

export const usePaginateUserGroups = ({ search }: { search?: string } = {}) => {
  return usePaginate<UserGroup>('user-groups', fetchUserGroups, { search })
}
